// src/modules/leadManagement.js
//
// Lead Management module manifest.
// Controls: LeadPool, InstallLeadPool, LeadDashboard routes and leadPoolStore.
// Note: leadStore is CORE (not in this module) because Dashboard depends on it.

export default {
  id: 'leadManagement',
  label: 'Lead Management',

  stores: {
    leadPoolStore: {
      import: () => import('@/stores/leadPoolStore'),
      storeId: 'leadPoolStore',
      init: (store, { roles }) => {
        if (roles.includes('admin') || roles.includes('sales')) {
          store.subscribe()
        }
      },
      cleanup: store => {
        store.unsubscribe?.()
      },
    },
    leadSettingsStore: {
      import: () => import('@/stores/leadSettingsStore'),
      storeId: 'leadSettingsStore',
      init: () => {
        /* lazy — loaded on demand */
      },
      cleanup: () => {},
    },
  },

  globalComponents: {},

  routes: ['LeadPool', 'InstallLeadPool', 'LeadDashboard'],

  nav: [
    { label: 'Lead Pool', routeName: 'LeadPool', group: 'tools' },
    { label: 'Leads', routeName: 'LeadDashboard', group: 'dashboard' },
  ],
}
